// extracted by mini-css-extract-plugin
export default {"timi_Container":"Timi_timi_Container__jI+70","timi_Wrapper":"Timi_timi_Wrapper__Kio7G","timi_Link":"Timi_timi_Link__XuPP+"};